import { render, staticRenderFns } from "./EditUbicazionePadreView.vue?vue&type=template&id=63072bf7&"
import script from "./EditUbicazionePadreView.vue?vue&type=script&lang=js&"
export * from "./EditUbicazionePadreView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports